import { useEffect, useState } from 'react';
import { Spline, MapPinPlus, ChevronDown, X } from 'lucide-react';
import { useFeatures } from '../lib/features';
import { useMode, ml } from '../lib/profiles';
import useCatalog from '../hooks/useCatalog';

// pipe / fitting stay on screen in fullscreen: tap = start with the last used item, arrow = choose another
export const openDrawer = (sub) => window.dispatchEvent(new CustomEvent('giss-drawer', { detail: sub }));
const QK = 'giss_quick_on';
const setQuick = (on) => { if (on) sessionStorage.setItem(QK, '1'); else sessionStorage.removeItem(QK); window.dispatchEvent(new Event('giss-quick')); };
// only after the user picked pipe / fitting in the tool list: the bar then stays for repeated use
export const rememberItem = (it, dn) => { if (!it) return; localStorage.setItem(`giss_last_${it.kind === 'pipe' ? 'pipe' : 'point'}`, JSON.stringify({ id: it.id, dn })); setQuick(true); };
const lastOf = (k) => { try { return JSON.parse(localStorage.getItem(`giss_last_${k}`)); } catch { return null; } };

export default function QuickBar({ t, net }) {
  const ft = useFeatures(), mode = useMode();
  const { items } = useCatalog();
  const [on, setOn] = useState(() => !!sessionStorage.getItem(QK));
  useEffect(() => { const f = () => setOn(!!sessionStorage.getItem(QK)); window.addEventListener('giss-quick', f); return () => window.removeEventListener('giss-quick', f); }, []);
  if (!on || net.draft || mode === 'garden' || (!ft.network && !ft.fittings)) return null;
  const go = (k, sub) => {
    const l = lastOf(k), it = l && items.find((x) => x.id === l.id);
    if (it) net.startItem(it, l.dn); else openDrawer(sub);
  };
  return (
    <div className="fs-quick mask" data-testid="fs-quick-bar">
      {ft.network && <><button className="fs-q" data-testid="fs-quick-pipe" onClick={() => go('pipe', 'pipe')}><Spline size={18} /> {ml(t, 'fsPipe', mode)}</button><button className="fs-q fs-q-more" data-testid="fs-quick-pipe-more" onClick={() => openDrawer('pipe')} aria-label={t.qbChoose}><ChevronDown size={16} /></button></>}
      {ft.fittings && <><button className="fs-q" data-testid="fs-quick-fit" onClick={() => go('point', 'fit')}><MapPinPlus size={18} /> {ml(t, 'fsFitting', mode)}</button><button className="fs-q fs-q-more" data-testid="fs-quick-fit-more" onClick={() => openDrawer('fit')} aria-label={t.qbChoose}><ChevronDown size={16} /></button></>}
      <button className="fs-q fs-q-close" data-testid="fs-quick-close" onClick={() => setQuick(false)} aria-label={t.btnCancel}><X size={16} /></button>
    </div>
  );
}
